import React, { useState, useEffect, useRef } from 'react'
import { motion, AnimatePresence } from 'framer-motion';
import MyScoreView from './MyScoreView';
import { copyStringToClipboard, convertMovesToEmojis } from '../logic/ShareStrings'
import RemoteScoreView from './RemoteScoreView';

const colors = ["#4A837F","#569278","#8AB29A", "#A1CEA0","#C5DBB8", "#B7E8C5","#A8DFD2","#8DC7B9","#569FA9"]

const textStyle = {
  userSelect: 'none',
  WebkitUserSelect: 'none',
  MozUserSelect: 'none',
  msUserSelect: 'none',
  background: 'none',
  pointerEvents: 'none'
};

const EmptyScoreView = ({size}) => {
  const containerStyle = {
    width: '100%',
    height: size * (115 / 300),
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center'
  }

  const histogramX = 110
  const histogramW = 170
  const numBuckets = 6
  const bucketW = 20
  const spacing = (histogramW - (numBuckets * bucketW)) / (numBuckets)
  const greyColor = "#d0d0d0"

  return <svg style={containerStyle} viewBox={`0 0 300 115`}>
    <g>
      <text fill={greyColor} x={20} y={30} fontSize={'25px'} fontFamily={'ProtoMono-Regular'} textAnchor='left' dominantBaseline={'middle'}>
        -
      </text>
      <text fill={greyColor} x={20} y={50} fontSize={'10px'} fontFamily={'ProtoMono-Regular'} textAnchor='left' dominantBaseline={'middle'}>
        Your Score
      </text>
      <text fill={greyColor} x={20} y={79} fontSize={'25px'} fontFamily={'ProtoMono-Regular'} textAnchor='left' dominantBaseline={'middle'}>
        -
      </text>
      <text fill={greyColor} x={20} y={100} fontSize={'10px'} fontFamily={'ProtoMono-Regular'} textAnchor='left' dominantBaseline={'bottom'}>
        Global Best
      </text>
      {
        [...Array(numBuckets)].map((_, i) => {
          return <rect
            key={i}
            x={histogramX + i * spacing + i * bucketW}
            y={88}
            width={bucketW}
            height={2}
            fill={greyColor}
          />
        })
      }
      <text
        x={150}
        y={50}
        fontSize={'11px'}
        fontFamily={'ProtoMono-Regular'}
        textAnchor='middle'
        dominantBaseline={'middle'}
        fill={greyColor}>
        no scores yet!
      </text>
      <text
        x={150}
        y={65}
        fontSize={'11px'}
        fontFamily={'ProtoMono-Regular'}
        textAnchor='middle'
        dominantBaseline={'middle'}
        fill={greyColor}>
        solve the puzzle to
      </text>
      <text
        x={150}
        y={80}
        fontSize={'11px'}
        fontFamily={'ProtoMono-Regular'}
        textAnchor='middle'
        dominantBaseline={'middle'}
        fill={greyColor}>
        set today's world best
      </text>
    </g>
  </svg>
}

const GameWinPopup = ({closePopup, playAgain, scoreInfo, isArchive}) => {
  const ref = useRef(null)
  const [viewHeight, setViewHeight] = useState(0)
  const [copiedSuccess, setCopiedSuccess] = useState(false)

  useEffect(() => {
    const updateDimensions = () => {
      if (ref.current) {
        setViewHeight(ref.current.clientHeight)
      }
    };

    // Call the updateDimensions function initially and on each update
    updateDimensions();
    window.addEventListener('resize', updateDimensions);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', updateDimensions);
    };
  }, []);

  const containerStyle = {
    height: '100%',
    width: '100%',
    backdropFilter: 'blur(8px)',
    paddingTop: `${viewHeight * .05}px`,
    backgroundColor: 'rgba(255, 255, 255)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  }

  const xButtonStyle = {
    position: 'absolute',
    height: '8%',
    width: '8%',
    top: '3%',
    right: '3%',
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
  };

  const containerTopBodyStyle = {
    fontFamily: 'ProtoMono-Regular',
    textAlign: 'center',
    // width: '92%',
    padding: `${viewHeight * .02}px`,
    fontSize: `${viewHeight * .08}px`,
    color: '#314f4d'
  }

  const containerBodyStyle = {
    fontFamily: 'Nunito',
    textAlign: 'center',
    // width: '92%',
    padding: `${viewHeight * .02}px`,
    paddingBottom: `${viewHeight * .01}px`,
    fontSize: `${viewHeight * .04}px`,
    color: '#314f4d'
  }

  const letsGoButtonStyle = {
    display: "flex",
    fontFamily: 'Nunito',
    fontSize: `${viewHeight * .03}px`,
    padding: `${viewHeight * .02}px ${viewHeight * .04}px`,
    margin: `${viewHeight * .03}px`,
    backgroundColor: "#569FA9",
    color: "white",
    borderRadius: "5px",
    cursor: "pointer",
    flexBasis: '50%',
    textAlign: 'center',
    justifyContent: "center",
    alignItems: "center"
  }
  const buttonsRow = {
    display: 'flex',
    marginLeft: `${viewHeight * .10}px`,
    marginRight: `${viewHeight * .10}px`,
    justifyContent: 'center',
    flexDirection: 'row'
  }
  const buttonsRowArchive = {
    display: 'flex',
    position: 'absolute',
    bottom: `${viewHeight * .10}px`,
    left: `${viewHeight * .125}px`,
    width: `${viewHeight * .75}px`,
    justifyContent: 'center',
    flexDirection: 'row'
  }
  const shareStyle = {
    marginLeft: `${viewHeight * .06}px`,
    marginRight: `${viewHeight * -.05}px`
  }
  const archiveStatBlock = {
    marginTop: `${viewHeight * .15}px`
  }

  const statLabelStyle = {
    fontFamily: 'ProtoMono-Regular',
    textAlign: 'center',
    padding: `${viewHeight * .01}px ${viewHeight * .01}px ${viewHeight * .01}px ${viewHeight * .01}px`,
    fontSize: `${viewHeight * .038}px`,
    color: '#314f4d'
  }

  const globalStatLabelStyle = {
    fontFamily: 'ProtoMono-Regular',
    textAlign: 'center',
    padding: `${viewHeight * .01}px ${viewHeight * .01}px ${viewHeight * .03}px ${viewHeight * .01}px`,
    fontSize: `${viewHeight * .038}px`,
    color: '#314f4d'
  }

  const copyScore = () => {
    if (scoreInfo.bestScore != '-') {
      copyStringToClipboard(convertMovesToEmojis(scoreInfo.thisWScore, scoreInfo.thisWMovesString, scoreInfo.gameNumber, scoreInfo.alignedNumber))
      setCopiedSuccess(true)
      setTimeout(() => {
        setCopiedSuccess(false);
      }, 1500);
    }
  }

  return <div ref={ref} style={containerStyle}>
    <div style={containerTopBodyStyle}>
      {'Victory!'}
    </div>
    { !isArchive && 
      <div>
        <div style={statLabelStyle}>
          {'Your Stats:'}
        </div>
        <MyScoreView scoreInfo={scoreInfo} size={viewHeight * .82}/>
        <div style={globalStatLabelStyle}>
          {`Today's Global Stats:`}
        </div>
        {
          (scoreInfo.remoteScoreInfo && scoreInfo.remoteScoreInfo.buckets) ?
          <RemoteScoreView scoreInfo={scoreInfo} size={viewHeight * .86} isArchive={isArchive}/> :
          <EmptyScoreView size={viewHeight * .86}/>
        }
        <div style={buttonsRow}>
          <motion.div 
            style={letsGoButtonStyle}
            whileHover={{ scale: 1.12, backgroundColor: "#314f4d" }}
            onClick={playAgain}
            >
            Play Again
          </motion.div>
          <motion.div 
            style={letsGoButtonStyle}
            whileHover={{ scale: 1.12, backgroundColor: "#314f4d" }}
            onClick={copyScore}
            >
            <div>{copiedSuccess ? "Copied" : "Share"}</div>
            { !copiedSuccess &&
              <img pointerEvents='none' src={process.env.PUBLIC_URL + '/svgs/share-white.svg'} width={viewHeight * .055} height={viewHeight * .04} style={shareStyle}/>
            }
          </motion.div>
        </div>
      </div>
    }
    { isArchive && 
      <div>
        <div style={archiveStatBlock}> 
          <div style={statLabelStyle}>
            {`Ali9n #${scoreInfo.gameNumber} Global Stats:`}
          </div>
          {
            (scoreInfo.remoteScoreInfo && scoreInfo.remoteScoreInfo.buckets) ?
            <RemoteScoreView scoreInfo={scoreInfo} size={viewHeight * .86} isArchive={isArchive}/> :
            <EmptyScoreView size={viewHeight * .86}/>
          }
        </div>
        <div style={buttonsRowArchive}>
          <motion.div 
            style={letsGoButtonStyle}
            whileHover={{ scale: 1.12, backgroundColor: "#314f4d" }}
            onClick={playAgain}
            >
            Play Again
          </motion.div>
          <motion.div 
            style={letsGoButtonStyle}
            whileHover={{ scale: 1.12, backgroundColor: "#314f4d" }}
            onClick={copyScore}
            >
            <div>{copiedSuccess ? "Copied" : "Share"}</div>
            { !copiedSuccess &&
              <img pointerEvents='none' src={process.env.PUBLIC_URL + '/svgs/share-white.svg'} width={viewHeight * .055} height={viewHeight * .04} style={shareStyle}/>
            }
          </motion.div>
        </div>
      </div>
    }
    <img 
      style={xButtonStyle}
      src={process.env.PUBLIC_URL + '/svgs/close.svg'}
      onClick={closePopup}
      id='closePopup'
    />
    
  </div>
}

export default GameWinPopup;


